import { rgba } from 'polished';
import styled from 'styled-components';
import Typography from '@atoms/Typography';
import Avatar from '@atoms/Avatar';
import { devices } from 'config/devices';
export var TopSection = styled.div.withConfig({
  displayName: "style__TopSection",
  componentId: "sc-1ug2ezp-0"
})(["background-image:", ";background-size:cover;background-position:center;height:21.875rem;margin-bottom:-10rem;@media ", "{margin-top:-1rem;}@media ", "{margin-bottom:-6rem;}display:flex;justify-content:center;"], function (_ref) {
  var background = _ref.background;
  return "url(".concat(background, ")");
}, devices.sm, devices.xs);
export var Title = styled(Typography).withConfig({
  displayName: "style__Title",
  componentId: "sc-1ug2ezp-1"
})(["&&{color:", ";margin-bottom:3.125rem;line-height:1em;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.white;
});
export var OrganisationContainer = styled.div.withConfig({
  displayName: "style__OrganisationContainer",
  componentId: "sc-1ug2ezp-2"
})(["background-color:", ";height:21.875rem;width:19rem;display:flex;justify-content:center;align-items:center;flex-direction:column;color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return rgba(theme.common.black, 0.75);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.white;
});
export var OrgAvatar = styled(Avatar).withConfig({
  displayName: "style__OrgAvatar",
  componentId: "sc-1ug2ezp-3"
})(["border:2px solid ", ";margin-bottom:1rem;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.primary.main;
});